(() => {
    if (window.__brRechargeProductFormBridgeInstalled) return;
    window.__brRechargeProductFormBridgeInstalled = true;

    const previousReady = window.RechargeSubscriptionWidgetReady;
    window.RechargeSubscriptionWidgetReady = (widget) => {
      if (typeof previousReady === 'function') previousReady(widget);

      const productId = String(widget?.product?.external_product_id || '');
      if (!productId || !widget?.events) return;

      let purchaseOption = widget.purchaseOption;
      let sellingPlanId = widget.sellingPlanId;
      let variantId = String(widget.variantId || '');

      const sync = () => {
        const root = document.querySelector(`product-info[data-product-id="${productId}"]`);
        const form = Array.from(root?.querySelectorAll('form[action*="/cart/add"]') || [])
          .find((candidate) => candidate.querySelector('button[type="submit"], input[type="submit"]'));
        if (!form) return;

        let input = form.querySelector('input[name="selling_plan"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.prepend(input);
        }
        input.value = purchaseOption === 'subscription' && sellingPlanId
          ? String(sellingPlanId)
          : '';
        input.disabled = false;

        variantId = String(form.querySelector('[name="id"]')?.value || variantId);
        const prices = window.SubscriptionWidgetConfig?.formattedPrices?.[variantId];
        const selectedPrice = purchaseOption === 'subscription' && sellingPlanId
          ? prices?.sellingPlans?.[sellingPlanId]?.price
          : prices?.unit;
        if (selectedPrice) {
          const priceText = String(selectedPrice);
          root.querySelectorAll('[id^="price-"]')
            .forEach((priceRoot) => {
              priceRoot.querySelectorAll('.price-item--regular, .price-item--last')
                .forEach((node) => {
                  if (node.textContent.trim() !== priceText.trim()) {
                    node.textContent = priceText;
                  }
                });
            });
        }
      };

      const syncSoon = () => {
        sync();
        window.setTimeout(sync, 0);
        window.setTimeout(sync, 100);
      };

      widget.events.onPurchaseOptionChange((nextPurchaseOption) => {
        purchaseOption = nextPurchaseOption;
        syncSoon();
      });
      widget.events.onSellingPlanChange((nextSellingPlanId) => {
        sellingPlanId = nextSellingPlanId;
        syncSoon();
      });
      widget.events.onVariantChange((nextVariantId) => {
        variantId = String(nextVariantId || variantId);
        syncSoon();
      });

      const root = document.querySelector(`product-info[data-product-id="${productId}"]`);
      if (root) {
        root.addEventListener('submit', sync, true);
      }
      syncSoon();
    };
})();
